import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {KlasseDTO} from "../../../models/klasse/KlasseDTO";
import {HttpHeaderService} from "../../utils/http/http-header.service";

@Injectable({
  providedIn: 'root'
})
export class KlasseService {

  configUrl = 'api/klasse';

  delHeaders: HttpHeaders;

  constructor(
    private http: HttpClient,
    private headerService: HttpHeaderService
  ) {
  }

  getKlassen(filterArchived: boolean): Observable<Array<KlasseDTO>> {
    return this.http.get<Array<KlasseDTO>>(this.configUrl + '/bulk?filterArchived=' + filterArchived,
      {headers: this.headerService.getAuthHeaderApplicationJson()}
    );
  }
}
